import {ListRequest} from "../../../generated/protocol";
import {PagerModel} from "./PagerModel";
import * as _ from "lodash";


export class ListUtils {
    static toListRequest<E extends ListRequest>(listRequestState: E, pager: PagerModel): E {
        var listRequest: any = _.clone(listRequestState);
        listRequest.limit = pager.limit;
        listRequest.orderBy = pager.orderBy;
        listRequest.ascending = pager.ascending;
        listRequest.offset = pager.offset;
        if (typeof(listRequest.offset) == "undefined") {
            listRequest.offset = 0;
        }
        return listRequest;
    };

    static toListPath<E extends ListRequest>(base: string, ...attributes: string[]): string {
        var pattern = base + "/:offset/:limit/:page/:ascending/**";

        console.log("PATTERN = ", pattern);
        return pattern;

    }
}


// WEBPACK FOOTER //
// ./src/app/ui/list/ListUtils.ts